import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
// import CrossGrayIcon from '../../common/images-new/cross-gray-icon.svg'
import ButtonBlue from '../../components/Button/ButtonBlue'
import { staticFiles } from '../../components/Helpers/Static'

const CROSS_GRAY_ICON = staticFiles.cross;

const ModalShare = ({handleClose, show}) => {
    const dispatch = useDispatch()
    const userProfile = useSelector(state => state.auth.user)
    const showcases = useSelector(state => state.showcase.showcases)
    // const groups = useSelector(state => state.communityGroups.groups)

    
    // let showcaseOptions = showcases.filter((showcase) => !showcasePostsId.includes(post.reflection_id))

    const profile = {
        name: userProfile ? userProfile.fullname : '',
        email: userProfile ? userProfile.email : '',
        programme: userProfile ? userProfile.programme : '',
        photo: userProfile ? userProfile.photo : '',
        cover: userProfile ? userProfile.cover : ''
    }  

    const showHideModal = show
        ? 'fixed top-0 left-0 w-full h-full bg-black bg-opacity-60 block modelIndex'
        : 'fixed top-0 left-0 w-full h-full bg-black bg-opacity-60 hidden modelIndex'   
        
    const tabs = [{text: 'Showcase', id:1}, {text: 'Group', id:2}, {text: 'Users', id:3}]
    const [currentPage, setCurrentPage] = useState(1)

    const groups = [{photo: profile.photo, fullname:'group 1'}, {photo: profile.photo, fullname:'group 2'},
                    {photo: profile.photo, fullname:'group 3'}
                    ]

    const [check, setCheck] = useState(false)
    const [selectedShowcase, setSelectedShowcase] = useState(0)

    function handleChange() {
        setCheck(!check)
        if(check) {
            // remove(item.reflection_id)
        } else {
            // add(item.reflection_id)
        }
    }

    const CheckBox = () => {
        let style = (check ? 'bg-green-400' : '')
        style += ' appearance-none border-2 border-black rounded-full w-8 h-8'
        return (
            <input type='checkbox' className={style} onChange={handleChange} />
        )
    }
        
    return(
        <div className={showHideModal} onClick={(e) => e.stopPropagation()}>
            <section className="fixed transform -translate-y-2/4 -translate-x-2/4 top-2/4 left-2/4 modelIndex">
                <div className="w-80 md:w-full bg-white px-4 md:px-8 py-5 my-5 rounded-md filter drop-shadow-md modelIndex">
               
                    <p className="font-bold flex justify-center text-xl mb-3">Share Post</p>
                    <img 
                        className="absolute right-4 md:right-8 top-6 cursor-pointer hover:opacity-60" 
                        onClick={handleClose} alt="cross" src={CROSS_GRAY_ICON}>
                    </img>
                    <hr className='w-full border-gray-300 mb-7'/>
                    
                    <div className="cursor-pointer flex flex-row items-center justify-center">
                        {tabs.map((tab) =>(
                            <div
                                key={tab.id}
                                className={`w-32 h-12 rounded-lg font-semibold
                                            font-semiboldflex flex 
                                            items-center justify-center bg-white
                                            ${currentPage === tab.id 
                                                ? `bg-blue text-white`
                                                : `bg-white text-black hover:opacity-70 border-gray-400 border-2`
                                            }`}  
                                onClick={() => setCurrentPage(tab.id)}
                            >
                                {tab.text} 
                            </div>
                        ))}
                    </div>
                   
                    <div className="my-5 overflow-x-auto" >
                        {currentPage === 1 && (
                            <div className="flex flex-row pt-2 justify-center">                            
                                <select 
                                    className="bg-gray pl-3 w-full h-12 rounded-lg border-2" 
                                    type="text"
                                    value={selectedShowcase}
                                    onChange={(e) => setSelectedShowcase(e.target.value)}
                                >
                                    {showcases && 
                                        showcases.map((option,index) => 
                                            <option key={index} value={option.showcase_id}>
                                                {option.showcase_name}
                                            </option>
                                        )

                                    }                                
                                </select>
                               
                            </div>
                        )}
                        {currentPage === 2 && (
                            <div className="flex flex-col">
                                <div className='flex flex-row mb-2 items-center '>
                                    <label className="text-sm mr-5 whitespace-nowrap font-bold">Share to Group</label>
                                    <input 
                                        className='h-10 w-full bg-gray-100 rounded-lg pl-4 pr-4' 
                                        type='search' 
                                        placeholder='type to search...'
                                        onChange={handleChange}
                                    />

                                </div>
                                <div className='flex flex-col h-32 overflow-auto space-y-3 my-5'>
                                    {groups.map((group, index) => (
                                        <div key={index} className="flex flex-row justify-between">
                                            <div className='flex items-center gap-6'>
                                                <img src={group.photo} className='rounded-full w-10 h-10' alt='profilepic' />
                                                <div className='font-semibold'>
                                                    {group.fullname}
                                                </div>
                             
                                            </div>
                                            <div className='flex items-center'>
                                                <CheckBox />
                                            </div>  
                                        </div>
                                    ))}
                                    
                                </div>
                            </div>
                        )}   
                        {currentPage === 3 && (
                            <div className="flex flex-col">
                                <div className='flex flex-row mb-2 items-center '>
                                    <label className="text-sm mr-5 whitespace-nowrap font-bold">Share to Friends</label>
                                    <input 
                                        className='h-10 w-full bg-gray-100 rounded-lg pl-4 pr-4' 
                                        type='search' 
                                        placeholder='type to search...'
                                        onChange={handleChange}
                                    />

                                </div>
                                <div className='flex flex-col h-32 overflow-auto space-y-3 my-5'>
                                    {groups.map((group, index) => (
                                        <div key={index} className="flex flex-row justify-between">
                                            <div className='flex items-center gap-6'>
                                                <img src={group.photo} className='rounded-full w-10 h-10' alt='profilepic' />
                                                <div className='font-semibold'>
                                                    {group.fullname}
                                                </div>
                            
                                            </div>
                                            <div className='flex items-center'>
                                                <CheckBox />
                                            </div>  
                                        </div>
                                    ))}
                                    
                                </div>
                            </div>
                        )} 
                    </div>
                    <div className="flex flex-row justify-end">
                        <div className="font-bold px-10 py-3 cursor-pointer hover:bg-gray-100 rounded-lg">DISCARD</div>
                        <ButtonBlue title='SHARE' />
                    </div>

                </div>
            </section>
        </div>
    )
} 

export default ModalShare